// Auto-generated file - do not edit manually
export const LOCALE_HASH = '228f8e7c';
